import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class BroadcastMessageService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getBroadcastMessages(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminBroadcastMessage/GetBroadcastMessages', data, messageService);
    }

    public getDetailBroadcastMessage(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminBroadcastMessage/GetDetailBroadcastMessage', data, messageService);
    }

    public createBroadcastMessage(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminBroadcastMessage/CreateBroadcastMessage', data, messageService);
    }
}
